/* ===== Carrito nativo Modazas: temporizador, protección de entrega y compatibilidad ===== */
(function () {
  function fmt(ms) {
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    if (d > 0) return d + ' d ' + p(h) + ' h ' + p(m) + ' min';
    if (h > 0) return p(h) + ':' + p(m) + ':' + p(s) + ' horas';
    return p(m) + ':' + p(s) + ' minutos';
  }
  function tick() {
    document.querySelectorAll('[data-cn-timer]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-cn-timer'));
      var bar = el.closest('.cn-bar');
      if (isNaN(end)) { if (bar) bar.hidden = true; return; }
      var left = end - Date.now();
      if (left <= 0) { if (bar) bar.hidden = true; return; }
      if (bar) bar.hidden = false;
      el.textContent = fmt(left);
    });
  }
  setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', tick);

  /* Banner "Alta demanda": el ciclo arranca (10:00) en el instante exacto en
     que el carrito pasa de 0 a 1 artículo — el momento de inicio se guarda
     en localStorage (no como atributo del carrito: así es síncrono, no
     depende de la red ni de la caché, y por tanto añadir/quitar artículos
     del carrito NUNCA lo toca). Cuenta atrás 10:00 -> 0:00 en tiempo real
     (cada segundo), se mantiene fija en 0:00 durante 2 minutos y vuelve a
     reiniciarse a 10:00, en bucle, mientras el carrito siga teniendo al
     menos 1 artículo. Solo se reinicia cuando el carrito llega a 0
     artículos y luego se añade un producto nuevo (carrito realmente nuevo). */
  var DEMAND_KEY = 'cn_demand_start';
  function getDemandStart() {
    try {
      var v = window.localStorage.getItem(DEMAND_KEY);
      return v ? Number(v) : 0;
    } catch (e) { return 0; }
  }
  function setDemandStart(v) {
    try {
      if (v === null) window.localStorage.removeItem(DEMAND_KEY);
      else window.localStorage.setItem(DEMAND_KEY, String(v));
    } catch (e) {}
  }
  function tickDemand() {
    var node = document.querySelector('[data-cn-demand-timer]');
    if (!node) return;
    var start = getDemandStart();
    if (!start) { if (node.textContent !== '10:00') node.textContent = '10:00'; return; }
    var COUNTDOWN = 10 * 60; // 600s contando hacia atrás
    var HOLD = 2 * 60; // 120s fijo en 0:00
    var CYCLE = COUNTDOWN + HOLD; // 720s por vuelta completa
    var elapsed = Math.floor((Date.now() - start) / 1000);
    if (elapsed < 0) elapsed = 0;
    var pos = elapsed % CYCLE;
    var remaining = pos < COUNTDOWN ? (COUNTDOWN - pos) : 0;
    var mm = Math.floor(remaining / 60);
    var ss = remaining % 60;
    var text = mm + ':' + (ss < 10 ? '0' : '') + ss;
    if (node.textContent !== text) node.textContent = text;
  }
  setInterval(tickDemand, 1000);
  document.addEventListener('DOMContentLoaded', tickDemand);

  // Arranca el ciclo de "Alta demanda" al llegar al primer artículo, y lo
  // borra cuando el carrito vuelve a quedar vacío (para que reinicie de
  // cero en la próxima compra). Todo síncrono vía localStorage: no hay
  // petición de red involucrada, así que es seguro llamarlo tras cualquier
  // cambio de cantidad sin riesgo de que reinicie el contador por error.
  function ensureDemandState() {
    var demandEl = document.querySelector('.cn-demand');
    if (demandEl) {
      var items = Number(demandEl.getAttribute('data-cn-items') || '0');
      if (items >= 1 && !getDemandStart()) {
        setDemandStart(Date.now());
        tickDemand();
      }
      return;
    }
    var d = document.querySelector('cart-drawer');
    if (d && d.classList.contains('is-empty')) {
      setDemandStart(null);
    }
  }

  // El tema deja la clase is-empty en el cajón tras añadir: la sincronizamos con el contenido real
  function syncEmpty() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    var has = !!d.querySelector('.cart-item');
    if (has && d.classList.contains('is-empty')) d.classList.remove('is-empty');
    if (!has && !d.classList.contains('is-empty') && d.querySelector('.drawer__inner-empty')) d.classList.add('is-empty');
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  async function refresh(silent) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var r = await fetch('/?sections=cart-drawer,cart-icon-bubble');
    var s = await r.json();
    if (silent) {
      var parse = function (h, sel) { return new DOMParser().parseFromString(h, 'text/html').querySelector(sel); };
      var a = parse(s['cart-drawer'], '#CartDrawer');
      var t = document.querySelector('#CartDrawer');
      if (a && t) t.innerHTML = a.innerHTML;
      var b = parse(s['cart-icon-bubble'], '.shopify-section');
      var tb = document.getElementById('cart-icon-bubble');
      if (b && tb) tb.innerHTML = b.innerHTML;
    } else {
      drawer.renderContents({ id: 0, sections: s });
    }
    syncEmpty();
    tickDemand();
    ensureDemandState();
  }
  window.monster_refresh = function () { return refresh(false); };
  window.monster_addToCart = async function (o) {
    var items = [{ id: Number(o.id), quantity: Number(o.quantity || 1) }];
    var r = await post('/cart/add.js', { items: items, sections: 'cart-drawer,cart-icon-bubble' });
    var j = await r.json();
    if (!r.ok) { console.warn('Carrito:', j.description || j.message); return j; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && j.sections) { drawer.renderContents(j); setTimeout(syncEmpty, 50); setTimeout(tickDemand, 50); setTimeout(ensureDemandState, 50); } else window.location.href = '/cart';
    return j;
  };

  // Icono de papelera por línea: elimina esa línea del carrito (cantidad 0)
  // reutilizando el mismo endpoint seguro /cart/change.js que ya usa el
  // sistema de "huérfanos" — no toca precios, variantes ni descuentos.
  var removeBusy = false;
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-cn-remove]') : null;
    if (!t || removeBusy) return;
    e.preventDefault();
    var key = t.getAttribute('data-cn-remove');
    if (!key) return;
    removeBusy = true;
    t.disabled = true;
    post('/cart/change.js', { id: key, quantity: 0 })
      .then(function () { return refresh(false); })
      .finally(function () { removeBusy = false; });
  });

  // Protección de entrega: el cliente la enciende/apaga; recordamos su elección
  // en un atributo del carrito para que no vuelva a activarse sola si la apagó.
  document.addEventListener('change', async function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-cn-prot]')) return;
    t.disabled = true;
    var vid = Number(t.getAttribute('data-vid'));
    try {
      if (t.checked) {
        await post('/cart/add.js', { items: [{ id: vid, quantity: 1 }] });
        await post('/cart/update.js', { attributes: { prot_off: '' } });
      } else {
        await post('/cart/change.js', { id: String(vid), quantity: 0 });
        await post('/cart/update.js', { attributes: { prot_off: '1' } });
      }
    } catch (err) { console.warn(err); }
    refresh(false);
  });

  // Si el interruptor se renderiza activado por defecto pero la protección aún
  // no es una línea real del carrito, la añadimos una vez para que el total
  // coincida con lo que ve el cliente.
  var protBusy = false;
  function ensureProtDefault() {
    if (protBusy) return;
    var el = document.querySelector('[data-cn-prot]');
    if (!el || el.disabled) return;
    if (el.checked && el.getAttribute('data-in-cart') === 'false') {
      protBusy = true;
      var vid = Number(el.getAttribute('data-vid'));
      post('/cart/add.js', { items: [{ id: vid, quantity: 1 }] })
        .then(function () { return refresh(true); })
        .finally(function () { protBusy = false; });
    }
  }

  // Quita la protección si ya no hay producto que la justifique
  var busy = false, timer;
  function checkOrphan() {
    syncEmpty();
    ensureProtDefault();
    ensureDemandState();
    if (busy) return;
    var o = document.querySelector('[data-cn-orphan]');
    if (!o) return;
    busy = true;
    post('/cart/change.js', { id: String(o.getAttribute('data-cn-orphan')), quantity: 0 })
      .then(function () { return refresh(true); })
      .finally(function () { busy = false; });
  }
  function watch() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    new MutationObserver(function () {
      // El selector de cantidad nativo (+/-) reemplaza el HTML del cajón con
      // una versión recién renderizada por Liquid, que siempre trae el texto
      // literal "10:00" de partida. Esto NO toca el valor guardado (localStorage),
      // pero hay que repintar el número correcto de inmediato (sin esperar el
      // siguiente tick de 1s) para que nunca se vea un reinicio visual.
      tickDemand();
      clearTimeout(timer); timer = setTimeout(checkOrphan, 300);
    }).observe(d, { childList: true, subtree: true });
    checkOrphan();
    tickDemand();
  }
  if (document.readyState !== 'loading') watch(); else document.addEventListener('DOMContentLoaded', watch);
})();
